import ContractCargoTaxiUpdateRequest, {
  ContractCargoTaxiUpdateRequestBody,
} from "./contracts-cargo-taxi-update.request";

const createBody = (
  request: ContractCargoTaxiUpdateRequest,
): ContractCargoTaxiUpdateRequestBody => {
  return {
    disabled: request.disabled,
    contactPassengerAfterMinutes: request.contactPassengerAfterMinutes,
    cancelByTaxiAllowed: request.cancelOrderByTaxiAllowed,
    editByTaxiAllowed: request.editOrderByTaxiAllowed,
    autoApprovalMinDistance: request.autoApprovalMinDistance,
    autoApprovalSwitch: request.autoApprovalSwitch,
    autoApprovalMinTime: request.autoApprovalMinTime,
    approvalDeadlineSwitch: request.approvalDeadlineSwitch,
    approvalDeadlineTime: request.approvalDeadlineTime,
  };
};

const contractCargoTaxiUpdateRequestFactory = {
  createBody,
};

export default contractCargoTaxiUpdateRequestFactory;
